module.exports = __webpack_public_path__ + "static/media/express-delivery.014c297a.svg";